import { useMemo } from 'react';

import { useShareChannelsAvailability } from './availability';
import type { ShareChannel, ShareConfig } from './shared/types';

export function useAvailableShareChannels<CH extends ShareChannel = ShareChannel>(
	channels: readonly CH[],
	config: ShareConfig,
): readonly CH[] {
	const availability = useShareChannelsAvailability(config);

	return useMemo(() => {
		const filtered = channels.filter((channel) => availability[channel]);
		return filtered;
	}, [channels, availability]);
}
